export default __webpack_public_path__ + "static/media/Ellipse-44.26fea49b.svg";